<app-dialog
  #dialog
  [key]="'quick-create-company-modal'"
  [action]="'quick-create-company-modal'"
  [headerTheme]="'simple'"
  [title]="'Cadastro Rápido de Empresa'"
  [maxWidth]="'750px'"
  (onClose)="resetState()">
  <div class="p-4">
    <form [formGroup]="form" appAutoFormGroup class="row g-3">
      <div class="col-12">
        <app-input
          [controlName]="'cnpj'"
          [label]="'CNPJ*'"
          [placeholder]="'00.000.000/0000-00'"
          (sendInputValue)="onCnpjChange($event.value)" />
        <small *ngIf="loadingCnpj" class="text-secondary">
          <i class="pi pi-spin pi-spinner"></i> Buscando dados do CNPJ...
        </small>
      </div>

      <div class="col-12">
        <app-input
          [controlName]="'corporateName'"
          [label]="'Razão Social*'"
          [placeholder]="'Razão social da empresa'" />
      </div>

      <div class="col-12">
        <app-input
          [controlName]="'tradeName'"
          [label]="'Nome Fantasia'"
          [placeholder]="'Nome fantasia (opcional)'" />
      </div>
    </form>

    <div class="mt-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="fw-semibold">Sócios</span>
        <app-button
          [label]="'Adicionar Sócio'"
          [icon]="'pi pi-user-plus'"
          [text]="true"
          type="button"
          (sendButtonClick)="openAddPartner()">
        </app-button>
      </div>

      <p-table [value]="partners" [tableStyle]="{ 'min-width': '100%' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Nome</th>
            <th>Qualificação</th>
            <th style="width: 48px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-partner let-i="rowIndex">
          <tr>
            <td>{{ partner.name }}</td>
            <td>{{ partner.qualification }}</td>
            <td class="text-center">
              <p-menu
                #actionMenu
                [model]="getPartnerMenuActions(partner, i)"
                [popup]="true"
                [appendTo]="'body'">
              </p-menu>
              <span class="ellipsis-trigger" (click)="actionMenu.toggle($event)">
                <i class="pi pi-ellipsis-v"></i>
              </span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center text-secondary py-3">Nenhum sócio cadastrado</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        [loadingText]="'Criando...'"
        label="Criar e adicionar ao grupo"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>

<app-company-partner-modal #partnerModal (confirmed)="onPartnerConfirmed($event)">
</app-company-partner-modal>
